import {
  ClearingExternalAccount,
  EXTERNAL_ACCOUNT_DESER,
  EXTERNAL_ACCOUNT_ELIGIBILITY_DESER,
  ExternalAccountEligibility,
  type EXTERNAL_ACCOUNT_ASSET_CLASS_SCOPE,
} from "../../tastyworks/external-account"
import type HttpClient from "../../tastyworks/http"
import { parseSingleResponse } from "../../tastyworks/response"

export class ExternalAccountService {
  private readonly client: HttpClient

  constructor(customerMeClient: HttpClient) {
    this.client = customerMeClient.nested(
      "accounts/:accountNumber/external-accounts"
    )
  }

  readonly create = async (
    accountNumber: string,
    assetClassScope: EXTERNAL_ACCOUNT_ASSET_CLASS_SCOPE
  ) => {
    const helper = await this.client.postJson(
      "",
      { "asset-class-scope": assetClassScope },
      { accountNumber }
    )
    return parseSingleResponse(
      helper,
      EXTERNAL_ACCOUNT_DESER.toParser(ClearingExternalAccount)
    )
  }

  readonly showEligibility = async (
    accountNumber: string,
    assetClassScope: EXTERNAL_ACCOUNT_ASSET_CLASS_SCOPE[]
  ) =>
    this.client.indexSimple(
      EXTERNAL_ACCOUNT_ELIGIBILITY_DESER.toParser(ExternalAccountEligibility),
      "eligibility",
      { accountNumber, "asset-class-scope": assetClassScope }
    )
}
